import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart from "./Cart";
import { generateCartItemsFrom } from "./Cart";

export let productsList;

const Products = () => {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loggedIn, setLoggedIn] = useState(token ? true : false);
  const [isLoading, setIsLoading] = useState(true);
  const [productsArray, setProductsArray] = useState([]);
  const isDesktop = useMediaQuery("(min-width:900px)");

  // const [searchText, setSearchText] = useState("");
  // const [fetchResultZero, setFetchResultZero] =useState();

  // const [cartItems, setCartItems] = useState([]);
  const [cartItems, setCartItems] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  // Definition of Data Structures used
  /**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product


/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /*
   @property {string} productId - Unique ID for the product
 */

  // const Products = () => {

  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */

  const performAPICall = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${config.endpoint}/products`);
      setProductsArray(response.data);

      productsList = [...response.data];
    } catch (error) {
      enqueueSnackbar(
        `${error.response.data.success}:${error.response.data.message}`,
        { variant: "error" }
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    performAPICall();
    fetchCart(token);
  }, []);

  // const handleSearchInputChange = (searchTextEvent) => {
  //   setSearchTextEvent(searchTextEvent.target.value);
  // };

  const produceGrid = () => {
    return (
      <Grid container spacing={2}>
        {productsArray.map((product) => {
          const { name, category, cost, rating, image, _id } = product;
          return (
            <Grid item xs={6} md={3} key={_id}>
              <ProductCard
                product={product}
                handleAddToCart={() =>
                  addToCart(token, cartItems, productsList, product._id, 1, {
                    preventDuplicate: true,
                  })
                }
              />
            </Grid>
          );
        })}
      </Grid>
    );
  };

  // useEffect(() => {
  //   performSearch(searchTextEvent);
  // },[searchTextEvent]);

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    try {
      let fetchSearchTextData = await axios.get(
        `${config.endpoint}/products/search?value=${text}`
      );
      // console.log(fetchSearchTextData.data);
      // if(fetchSearchTextData.data.length > 0){
      setProductsArray(fetchSearchTextData.data);

      // setFetchResultZero(true);
      // }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setProductsArray([]);
      } else {
        enqueueSnackbar(
          "Something went wrong. Check that the backend logs for more details",
          { variant: "error" }
        );
      }
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  let debounceTimer;
  const debounceSearch = (event, debounceTimeout) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      performSearch(event.target.value);
    }, debounceTimeout);
  };

  // useEffect(() => {
  //   debounceSearch()
  // }, [searchText]);

  // const debounceSearch = (event, debounceTimeout) => {
  // };

  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
  const fetchCart = async (token) => {
    if (!token) return;
    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
      // console.log(token);
      const response = await axios.get(`${config.endpoint}/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const cartItems = generateCartItemsFrom(response.data, productsList);
      setCartItems(cartItems);
      return response.data;
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  // handleAddToCart(product) {
  //   addToCart(token, )
  // }

  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  const isItemInCart = (items, productId) => {
    return items.some((cartItem) => cartItem.productId === productId);
    /*
     for (let i = 0; i < items.length; i++) {
    if (items[i].productId === productId) {
      return true;
    }
  }
  return false;
    */
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
  const addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    if (!loggedIn) {
      enqueueSnackbar("Login to add an item to the Cart", {
        variant: "warning",
      });
      return;
    }
    if (isItemInCart(items, productId) && options.preventDuplicate) {
      enqueueSnackbar(
        "Item already in cart. Use the cart sidebar to update quantity or remove item.",
        { variant: "warning" }
      );
      return;
    }
    let postCartResponse = await axios.post(
      `${config.endpoint}/cart`,
      {
        productId: productId,
        qty: qty,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    setCartItems(generateCartItemsFrom(postCartResponse.data, productsList));
  };

  const handleQuantity = (cartItem, isIncreaseOperation) => {
    addToCart(
      token,
      cartItems,
      productsList,
      cartItem.productId,
      isIncreaseOperation ? cartItem.qty + 1 : cartItem.qty - 1,
      { preventDuplicate: false }
    );
  };

  return (
    <div>
      <Header>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
        <Box className="search">
          <TextField
            className="search-desktop"
            size="small"
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search color="primary" />
                </InputAdornment>
              ),
            }}
            placeholder="Search for items/categories"
            name="search"
            // value={searchText}
            // onChange={(event) => {setSearchTextEvent(event.target.value);performSearch(searchTextEvent)}}
            onChange={(event) => {
              debounceSearch(event, 500);
            }}
          />
        </Box>
      </Header>

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        // value={searchText}
        // onChange={(event) => {setSearchTextEvent(event.target.value);performSearch(searchTextEvent)}}
        onChange={(event) => {
          debounceSearch(event, 500);
        }}
      />
      <div className="big-container">
        <div className="big-container-first-div">
          <Grid container>
            <Grid item className="product-grid">
              <Box className="hero">
                <p className="hero-heading">
                  India’s{" "}
                  <span className="hero-highlight">FASTEST DELIVERY</span> to
                  your door step
                </p>
              </Box>
            </Grid>
          </Grid>
          <Box>
            <Stack spacing={2} mt={3} mb={2} mx={2}>
              {isLoading && (
                <div className="loading" align="center">
                  <CircularProgress />
                  <p>Loading Products...</p>
                </div>
              )}
              {!isLoading && productsArray.length > 0
                ? produceGrid()
                : !isLoading &&
                  productsArray.length === 0 && (
                    <div className="loading">
                      <SentimentDissatisfied />
                      <p>No products found</p>
                    </div>
                  )}
              {/* {(!isLoading && productsArray.length > 0) ? produceGrid() : ( 
            (<div className="loading"><SentimentDissatisfied /><p>No products found</p></div>)) } */}
            </Stack>
          </Box>
          {loggedIn && !isDesktop && (
            <Grid sx={{ backgroundColor: "#E9F5E1", padding: "2px" }}>
              <Cart
                products={productsList}
                items={cartItems}
                handleQuantity={handleQuantity}
              />
            </Grid>
          )}
          <Footer />
        </div>

        {/* TODO: CRIO_TASK_MODULE_CART - Display the Cart component */}

        {loggedIn && isDesktop && (
          <div style={{ backgroundColor: "#E9F5E1" }}>
            <Grid item xs={12} md={3} className="cart-desktop-box">
              <Cart
                products={productsList}
                items={cartItems}
                handleQuantity={handleQuantity}
              />
            </Grid>
          </div>
        )}
      </div>
    </div>
  );
};
export default Products;
